<div *ngIf="isVisible" class="header-dropdown-menu !h-auto !w-[318px] !min-height-0">
  <div class="notification-panel">

    <div class="notification-panel-header flex h-[50px] items-center gap-[10px] px-[14px]">
      <!-- <button class="header-icon-box flex h-[30px] w-[30px] items-center justify-center rounded-[2px] transition-colors hover:bg-white/20">
        <i class="fas fa-caret-up text-[20px] text-white"></i>
      </button> -->
      <h3 class="text-[14px] font-[600] tracking-wide text-white m-0">Notifications</h3>
      <button (click)="closePanel()"
        class="header-close-btn ml-auto flex h-[30px] w-[30px] items-center justify-center rounded-[8px] transition-all"
        aria-label="Close notifications">
        <i class="fas fa-times text-[14px] text-white"></i>
      </button>
    </div>

    <div #scrollContainer class="notification-scroll space-y-[20px] px-[14px] py-[20px]" (scroll)="onScroll($event)">
      <div *ngIf="notifications.length === 0" class="state-text py-6 text-center text-[12px] text-white">
        No notifications
      </div>

      <div *ngIf="notifications.length > 0" class="space-y-[20px]">
        <div *ngFor="let notification of notifications; let i = index; trackBy: trackByNotificationId"
          class="notification-row group relative flex cursor-pointer items-start gap-[6px]"
          (click)="onNotificationClick(notification)" [class.removing]="notification.removing">
          <div class="notification-icon flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center rounded-[4px]">
            <i class="fas fa-wallet text-[14px] text-white"></i>
          </div>

          <div class="notification-content min-w-0 flex-1 pt-[7px]">
            <div class="notification-meta mb-[2px] text-right text-[9px] font-[500] text-white">
              <span>{{ notification.AddedDate | date : "dd/MM/yyyy, hh:mm a" }}</span>
            </div>

            <div class="notification-card relative rounded-[0.75rem] p-[8px]">
              <div class="flex items-start justify-between gap-[6px]">
                <strong class="block text-[10px] font-[700] text-white">{{ notification.Type }}</strong>
                <button type="button"
                  class="close-btn z-10 flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center rounded-[2px] text-white transition-colors duration-200 hover:bg-white/30"
                  (click)="removeNotification(i, $event)" aria-label="Remove notification">
                  <i class="fas fa-times text-[10px]"></i>
                </button>
              </div>
              <p class="mt-[4px] text-[9.5px] leading-[13px] text-[var(--modal-text)]">{{ notification.Notifications }}
              </p>
            </div>
          </div>
        </div>

        <div *ngIf="isLoading" class="state-text py-2 text-center text-[10px] text-white">Loading more...</div>
        <div *ngIf="!hasMore && notifications.length > 0" class="state-text py-2 text-center text-[10px] text-white">No
          more notifications.</div>
      </div>
    </div>

  </div>
</div>